import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/aitoken'
  },
  {
    path: '/index',
    name: 'home',
    component: () => import('@/views/home/index.vue')
  },
 
  {
    path: '/withdrawal',
    name: 'withdrawal',
    component: () => import('@/views/home/withdrawal.vue')
  },
  {
    path: '/withdrawal_com',
    name: 'withdrawal',
    component: () => import('@/views/home/withdrawal_com.vue')
  },
  {
    path: '/commission_to_balance',
    name: 'commission_to_balance',
    component: () => import('@/views/home/commission_to_balance.vue')
  },
  {
    path: '/withdrawal_record',
    name: '余额提现记录',
    component: () => import('@/views/home/withdrawal_record.vue')
  },
  {
    path: '/withdrawal_com_record',
    name: '佣金提现记录',
    component: () => import('@/views/home/withdrawal_com_record.vue')
  },

  {
    path: '/wd',
    name: 'wd',
    component: () => import('@/views/home/wd.vue')
  },

  {
    path: '/record',
    name: '余额记录',
    component: () => import('@/views/home/record.vue')
  },
  {
    path: '/record_com',
    name: '佣金记录',
    component: () => import('@/views/home/record_com.vue')
  },
  {
    path: '/getbamboocoin',
    name: 'GetBambooCoin',
    component: () => import('@/views/getbamboocoin/index.vue')
  },
  {
    path: '/language',
    name: 'Language',
    component: () => import('@/views/language/index.vue')
  },
  {
    path: '/aitoken',
    component: () => import('@/views/aitoken/Layout.vue'),
    children: [
      {
        path: '',
        name: 'AiTokenHome',
        component: () => import('@/views/aitoken/Home.vue')
      },
      {
        path: 'business',
        name: 'AiTokenBusiness',
        component: () => import('@/views/aitoken/Business.vue')
      },
      {
        path: 'orders',
        name: 'AiTokenOrders',
        component: () => import('@/views/aitoken/Orders.vue')
      },
      {
        path: 'referral',
        name: 'AiTokenReferral',
        component: () => import('@/views/aitoken/Referral.vue')
      },
      {
        path: 'customer-service',
        name: 'AiTokenCustomerService',
        component: () => import('@/views/aitoken/CustomerService.vue')
      }
    ]
  },
]

// const router = new VueRouter({
//   routes
// })
const router = new VueRouter({
  mode: 'history',
  base: '/',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  }
})
export default router
